const KEY = "ffair_2fa_prompt_on_login";

let consumed = false;
let pending = false;

export const flagTwoFactorPromptOnLogin = (): void => {
  consumed = false;
  pending = false;
  sessionStorage.setItem(KEY, "1");
};

export const consumeTwoFactorPromptOnLogin = (): boolean => {
  if (!consumed) {
    consumed = true;
    pending = sessionStorage.getItem(KEY) === "1";
    if (pending) sessionStorage.removeItem(KEY);
  }

  return pending;
};
